if($('.subcategories').length){
    $('.subcategories img').each(function(){
        $(this).attr('src', $(this).attr('src').replace('/thumb/', '/orig/'))
    })
}